"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ORG_SWITCHER = void 0;
exports.appendMenuItem = appendMenuItem;
exports.appendOrgSwitcher = appendOrgSwitcher;
exports.default = void 0;
exports.getAccountUrl = getAccountUrl;
exports.getLogoutUrl = getLogoutUrl;
exports.getProductPath = getProductPath;
exports.getStopImpersonationUrl = getStopImpersonationUrl;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Icon = require("../Icon");
var _colors = require("../style/colors");
var _fonts = require("../style/fonts");
var _Link = _interopRequireDefault(require("../Link"));
var _DropdownMenu = _interopRequireDefault(require("../DropdownMenu"));
var _BufferLogo = _interopRequireDefault(require("./BufferLogo"));
var _NavBarMenu = _interopRequireDefault(require("./NavBarMenu/NavBarMenu"));
var _NavBarProducts = _interopRequireDefault(require("./NavBarProducts/NavBarProducts"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function getProductPath(baseUrl) {
  const result = baseUrl.match(/https*:\/\/(.+)\.buffer\.com/);
  let productPath = baseUrl;
  if (result instanceof Array) {
    ;
    [, productPath] = result;
  }
  return productPath;
}
function getRedirectUrl(baseUrl) {
  const productPath = getProductPath(baseUrl);
  return `https://${productPath}.buffer.com`;
}
function getLogoutUrl() {
  let baseUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  const productPath = getProductPath(baseUrl);
  return `https://login${productPath.includes('local') ? '.local' : ''}.buffer.com/logout?redirect=${getRedirectUrl(baseUrl)}`;
}
function getAccountUrl() {
  let baseUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  let user = arguments.length > 1 ? arguments[1] : undefined;
  return `https://account.buffer.com?redirect=${getRedirectUrl(baseUrl)}&username=${encodeURI(user.name)}`;
}
const ORG_SWITCHER = exports.ORG_SWITCHER = 'org_switcher';
function getStopImpersonationUrl() {
  const {
    hostname
  } = window.location;
  if (!hostname.endsWith('buffer.com')) {
    return null;
  }
  return `https://admin${hostname.includes('local') ? '-next.local' : ''}.buffer.com/clearImpersonation`;
}
const NavBarStyled = /*#__PURE__*/_styledComponents.default.nav.withConfig({
  displayName: "NavBar__NavBarStyled",
  componentId: "bufferapp-ui__sc-1l2rqgg-0"
})(["background:#fff;border-bottom:1px solid ", ";box-shadow:0 1px 10px -5px rgba(0,0,0,0.15);display:flex;height:56px;justify-content:space-between;position:relative;width:100vw;"], _colors.gray);
const NavBarLeft = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "NavBar__NavBarLeft",
  componentId: "bufferapp-ui__sc-1l2rqgg-1"
})(["display:flex;"]);
const NavBarRight = /*#__PURE__*/_styledComponents.default.nav.withConfig({
  displayName: "NavBar__NavBarRight",
  componentId: "bufferapp-ui__sc-1l2rqgg-2"
})(["display:flex;"]);
const NavBarHelp = /*#__PURE__*/_styledComponents.default.a.withConfig({
  displayName: "NavBar__NavBarHelp",
  componentId: "bufferapp-ui__sc-1l2rqgg-3"
})(["align-items:center;color:#fff;color:", ";display:flex;font-size:16px;font-family:", ";font-weight:", ";height:100%;padding:0 24px;position:relative;text-decoration:none;z-index:2;&:hover{color:", ";background-color:", ";}cursor:pointer;"], props => props.active ? _colors.blueDarker : _colors.grayDark, _fonts.fontFamily, _fonts.fontWeightMedium, props => props.active ? _colors.blueDarker : _colors.grayDark, _colors.grayLighter);
const NavBarHelpText = /*#__PURE__*/_styledComponents.default.span.withConfig({
  displayName: "NavBar__NavBarHelpText",
  componentId: "bufferapp-ui__sc-1l2rqgg-4"
})(["margin-left:8px;"]);
const NavBarVerticalRule = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "NavBar__NavBarVerticalRule",
  componentId: "bufferapp-ui__sc-1l2rqgg-5"
})(["background-color:", ";height:24px;margin-left:-1px;margin-right:-1px;position:relative;top:50%;transform:translateY(-50%);width:1px;z-index:1;"], _colors.grayLight);
const SkipToMainLink = /*#__PURE__*/(0, _styledComponents.default)(_Link.default).withConfig({
  displayName: "NavBar__SkipToMainLink",
  componentId: "bufferapp-ui__sc-1l2rqgg-6"
})(["position:absolute;top:-1000px;left:-1000px;height:1px;width:1px;overflow:hidden;:focus{left:auto;top:auto;position:relative;height:auto;width:auto;overflow:visible;margin:auto;margin-left:10px;}"]);
function appendMenuItem(ignoreMenuItems, menuItem) {
  if (!ignoreMenuItems) {
    return menuItem;
  }
  return ignoreMenuItems.includes(menuItem.id) ? null : menuItem;
}
function getNetworkIcon(item) {
  if (!item.network) return null;
  switch (item.network) {
    case 'instagram':
      return /*#__PURE__*/_react.default.createElement(_Icon.Instagram, {
        size: "medium"
      });
    case 'twitter':
      return /*#__PURE__*/_react.default.createElement(_Icon.Twitter, {
        size: "medium"
      });
    case 'facebook':
      return /*#__PURE__*/_react.default.createElement(_Icon.Facebook, {
        size: "medium"
      });
    case 'pinterest':
      return /*#__PURE__*/_react.default.createElement(_Icon.Pinterest, {
        size: "medium"
      });
    case 'linkedin':
      return /*#__PURE__*/_react.default.createElement(_Icon.LinkedIn, {
        size: "medium"
      });
    default:
      break;
  }
}
function appendOrgSwitcher(orgSwitcher) {
  if (!orgSwitcher || !orgSwitcher.menuItems) {
    return [];
  }
  return orgSwitcher.menuItems.map((item, index) => {
    item.type = ORG_SWITCHER;
    if (orgSwitcher.title && index === 0) {
      item.hasDivider = true;
      item.dividerTitle = orgSwitcher.title;
    }
    if (item.subItems) {
      item.subItems.forEach(subItem => {
        subItem.icon = getNetworkIcon(subItem);
      });
    }
    if (!item.subItems || item.subItems.length === 0) {
      item.defaultTooltipMessage = 'No channels connected yet.';
    }
    return item;
  });
}
class NavBar extends _react.default.Component {
  shouldComponentUpdate(nextProps) {
    return nextProps.user.name !== this.props.user.name || nextProps.user.email !== this.props.user.email || nextProps.isImpersonation !== this.props.isImpersonation || nextProps.products !== this.props.products || nextProps.orgSwitcher !== this.props.orgSwitcher;
  }
  render() {
    const {
      products,
      activeProduct,
      user,
      helpMenuItems,
      onLogout,
      displaySkipLink,
      isImpersonation,
      orgSwitcher
    } = this.props;
    const orgSwitcherHasItems = orgSwitcher && orgSwitcher.menuItems && orgSwitcher.menuItems.length > 0;
    return /*#__PURE__*/_react.default.createElement(NavBarStyled, {
      "aria-label": "Main menu"
    }, /*#__PURE__*/_react.default.createElement(NavBarLeft, null, displaySkipLink && ( /*#__PURE__*/_react.default.createElement(SkipToMainLink, {
      href: "#main"
    }, "Skip to main content")), /*#__PURE__*/_react.default.createElement(_BufferLogo.default, null), /*#__PURE__*/_react.default.createElement(NavBarVerticalRule, null), /*#__PURE__*/_react.default.createElement(_NavBarProducts.default, {
      products: products,
      activeProduct: activeProduct
    })), /*#__PURE__*/_react.default.createElement(NavBarRight, null, helpMenuItems && ( /*#__PURE__*/_react.default.createElement(_DropdownMenu.default, {
      xPosition: "right",
      ariaLabel: "Help Menu",
      ariaLabelPopup: "Help",
      menubarItem: /*#__PURE__*/_react.default.createElement(NavBarHelp, null, /*#__PURE__*/_react.default.createElement(_Icon.Info, null), /*#__PURE__*/_react.default.createElement(NavBarHelpText, null, "Help")),
      items: helpMenuItems
    })), /*#__PURE__*/_react.default.createElement(NavBarVerticalRule, null), /*#__PURE__*/_react.default.createElement(_DropdownMenu.default, {
      xPosition: "right",
      ariaLabel: "Account Menu",
      ariaLabelPopup: "Account",
      horizontalOffset: "-16px",
      isImpersonation: isImpersonation,
      menubarItem: /*#__PURE__*/_react.default.createElement(_NavBarMenu.default, {
        user: user,
        isImpersonation: isImpersonation
      }),
      items: [...appendOrgSwitcher(orgSwitcher), appendMenuItem(user.ignoreMenuItems, {
        id: 'account',
        title: 'Account',
        icon: /*#__PURE__*/_react.default.createElement(_Icon.Person, {
          color: _colors.gray
        }),
        hasDivider: orgSwitcherHasItems,
        onItemClick: () => {
          window.location.assign(getAccountUrl(window.location.href, this.props.user));
        }
      }), ...user.menuItems, appendMenuItem(user.ignoreMenuItems, isImpersonation ? {
        id: 'Stop Impersonation',
        title: 'Stop Impersonation',
        icon: /*#__PURE__*/_react.default.createElement(_Icon.Cross, {
          color: _colors.gray
        }),
        hasDivider: user.menuItems && user.menuItems.length > 0,
        onItemClick: () => {
          window.location.assign(getStopImpersonationUrl());
        }
      } : {
        id: 'logout',
        title: 'Logout',
        icon: /*#__PURE__*/_react.default.createElement(_Icon.ArrowLeft, {
          color: _colors.gray
        }),
        hasDivider: user.menuItems && user.menuItems.length > 0,
        onItemClick: () => {
          if (typeof onLogout === 'function') onLogout();
          window.location.assign(getLogoutUrl(window.location.href));
        }
      })].filter(e => e)
    })));
  }
}
NavBar.propTypes = {
  products: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.string,
    isNew: _propTypes.default.bool,
    href: _propTypes.default.string
  })),
  activeProduct: _propTypes.default.oneOf(['publish', 'analyze', 'engage']),
  user: _propTypes.default.shape({
    name: _propTypes.default.string.isRequired,
    email: _propTypes.default.string.isRequired,
    avatar: _propTypes.default.string,
    ignoreMenuItems: _propTypes.default.arrayOf(_propTypes.default.string),
    menuItems: _propTypes.default.arrayOf(_propTypes.default.shape({
      id: _propTypes.default.string.isRequired,
      title: _propTypes.default.string.isRequired,
      component: _propTypes.default.func,
      hasDivider: _propTypes.default.bool,
      onItemClick: _propTypes.default.func
    })).isRequired
  }).isRequired,
  helpMenuItems: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.string.isRequired,
    title: _propTypes.default.string.isRequired,
    component: _propTypes.default.node,
    hasDivider: _propTypes.default.bool,
    onItemClick: _propTypes.default.func
  })),
  isImpersonation: _propTypes.default.bool,
  onLogout: _propTypes.default.func,
  displaySkipLink: _propTypes.default.bool,
  orgSwitcher: _propTypes.default.shape({
    title: _propTypes.default.string.isRequired,
    menuItems: _propTypes.default.arrayOf(_propTypes.default.shape({
      id: _propTypes.default.string.isRequired,
      title: _propTypes.default.string.isRequired,
      selected: _propTypes.default.bool.isRequired,
      onItemClick: _propTypes.default.func
    })).isRequired
  })
};
NavBar.defaultProps = {
  products: [],
  activeProduct: undefined,
  helpMenuItems: null,
  isImpersonation: false,
  onLogout: undefined,
  displaySkipLink: false,
  orgSwitcher: undefined
};
var _default = exports.default = NavBar;